import React, { useEffect, useState } from "react";
import RequestListTab from "./requestscreens/RequestListTab";
import RequestDetails from "./requestscreens/RequestDetails";
import { useStore } from "../../../hooks/useStore";

const RequestTab = ({
  projectId,
  currentTab,
  selectedReqId,
  activeTabView,
  setActiveView,
  setUpdateDetails,
  memberPermission,
  userRole,
  setCurrentTab,
  setSelectedReqId,
  isInternalProject,
  projectTeam
}) => {
  const [store] = useStore();
  const [activeTab, setActiveTab] = useState("requestList");
  const [selectedRequestId, setSelectedRequestId] = useState("");
  const [parentId, setParentId] = useState("");

  useEffect(() => {
    if (currentTab == 2) {
      if (selectedReqId) {
        setActiveTab("requestDetails");
      } else {
        setActiveTab("requestList");
      }
    }
  }, [currentTab, selectedReqId]);

  useEffect(() => {
    if (activeTabView == "requestList") {
      setActiveTab("requestList");
      setActiveView("");
    }
  }, [activeTabView]);

  const handleRequestClick = (requestId, parentRequestId) => {
    setSelectedRequestId(requestId); // Store the clicked request ID
    setParentId(parentRequestId);
    setActiveTab("requestDetails"); // Switch to the details tab
  };

  const handleRequestCompleted = () => {
    setActiveTab("requestList");
    setUpdateDetails();
  };

  // useEffect(() => {
  //   if (currentTab == 2 && !selectedReqId) setActiveTab("requestList");
  // }, [currentTab]);

  return (
    <div>
      {activeTab === "requestList" && (
        <RequestListTab
          projectId={projectId}
          currentTab={currentTab}
          onRequestClick={handleRequestClick} // Pass handler to the child
          memberPermission={memberPermission}
          userRole={userRole}
          isInternalProject={isInternalProject}
          projectTeam={projectTeam}
        />
      )}
      {activeTab === "requestDetails" && (
        <RequestDetails
          currentTab={currentTab}
          selectedReqId={selectedReqId}
          requestId={selectedRequestId}
          parentId={parentId}
          setActiveTab={handleRequestCompleted}
          setUpdateDetails={setUpdateDetails}
          memberPermission={memberPermission}
          userRole={userRole}
          setCurrentTab={setCurrentTab}
          setSelectedReqId={setSelectedReqId}
          isInternalProject={isInternalProject}
          projectTeam={projectTeam}
        />
      )}
    </div>
  );
};

export default RequestTab;
